import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Build the full URL for an API-served image.
 * Handles both file IDs and relative paths (e.g., "/images/xxx").
 * Uses VITE_API_URL to ensure images are fetched from the API server.
 */
export function getImageUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  const apiUrl = import.meta.env.VITE_API_URL || '';
  // If it's already a relative path starting with /, just prefix it
  if (path.startsWith('/')) {
    return `${apiUrl}${path}`;
  }
  // Otherwise treat it as a file ID
  return `${apiUrl}/images/${path}`;
}
